import React from 'react';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} La Provence Bakery. All rights reserved.</p>
      <p style={{ marginTop: '0.5rem', fontSize: '0.9rem' }}>
        <Link to="/privacy">Privacy Policy</Link>
      </p>
    </footer>
  );
}

export default Footer;